import React from "react";

import { ContextProps } from "./useNavBar.types";

export const NavBarContext = React.createContext<ContextProps | null>(null);
